import { useQuery } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * Who may be named an owner of a schedule covering `targetIds`.
 *
 * tRPC-only, as there is no GraphQL equivalent, so this is a thin `useQuery`
 * wrapper rather than a `createQueryHook` bridge.
 *
 * Unlike `useGetSchedulableTargets` it is not held back on an empty list: with
 * no targets chosen the answer is every domain manager, which is the picker's
 * starting state. It re-fires as the selection changes, because eligibility
 * depends on the targets.
 */
export const useGetEligibleScheduleOwners = (targetIds: string[]) => {
  const trpc = useTRPC();

  return useQuery(
    trpc.frontend.scheduler.getEligibleOwners.queryOptions({
      TargetIds: targetIds,
    })
  );
};
